import React from "react";
import Input from "Components/UI/Input";
import { useFormContext } from "react-hook-form";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
const activestatus = [
  { id: "1", label: "Yes", value: true },
  { id: "0", label: "No", value: false },
];

const LeaveTypeForm = ({ mode = "I", onSubmit, show = false, handleClose }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    trigger,
    setValue,
  } = useFormContext();
  console.log(errors);
  return (
    <Modal show={show} onHide={handleClose} animation={true} centered>
      <Modal.Header
        className="modal-header border-0 custom-modal-header"
        style={{ justifyContent: "space-between" }}
      >
        <div className="page-title">
          <h4>{mode === "I" ? "Add Leave Type" : "Edit Leave Type"}</h4>
        </div>
        <button type="button" className="close" onClick={handleClose}>
          <span aria-hidden="true">×</span>
        </button>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit(onSubmit)} className="needs-validation">
          <div className="form-row">
            <div className="mb-3">
              <Input
                name="leaveName"
                label="Leave Name"
                placeholder="Leave Name"
                className={`form-control ${
                  errors.leaveName ? "is-invalid" : ""
                }`}
                labelClassName="form-label"
                type="text"
                required={true}
              />
            </div>
            <div className="mb-3">
              <Input
                name="isActive"
                type="commonSelect"
                placeholder="Active Status"
                className={`form-control ${
                  errors.isActive ? "is-invalid" : ""
                }`}
                label="Active Status"
                labelClassName="form-label"
                optionData={activestatus}
                required={true}
                requiredMessage="Active Status is required"
                onChange={(selectedOption) => {
                  console.log(selectedOption);
                  setValue("isActive", selectedOption);
                  trigger("isActive");
                }}
                defaultValue={watch("isActive")}
                getPopupContainer={(trigger) => trigger.parentNode}
              />
            </div>
          </div>
          <div className="text-end mt-3">
            <button type="submit" className="btn btn-primary">
              {mode === "I" ? "Add" : "Update"}
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

LeaveTypeForm.propTypes = {
  mode: PropTypes.oneOf(["I", "E"]),
  onSubmit: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default LeaveTypeForm;
